import PngObblighi from '../../icons/Obblighi.png';
import PngLimiti from '../../icons/Limiti.png';
import PngAltreInfo from '../../icons/AltreInfo.png';
import ReactTooltip from 'react-tooltip';
import splitStringByLength from '../../util/splitStringByLength.js';

export default ({tariffa}) => {
    return (
        <>
            {(tariffa.Limiti != '' || tariffa.Obblighi != '' || tariffa.AltreInfo != '') && <br/>}
            {tariffa.Limiti != '' &&
                <>
                    <img src={PngLimiti} data-for={`Limiti-${tariffa.Progressivo}`} data-tip={splitStringByLength(tariffa.Limiti)} width="20"/>
                    <ReactTooltip id={`Limiti-${tariffa.Progressivo}`} backgroundColor='#ca5100' effect="solid" html={true}/>
                </>
            }
            {tariffa.Obblighi != '' &&
                <>
                    <img src={PngObblighi} data-for={`Obblighi-${tariffa.Progressivo}`} data-tip={splitStringByLength(tariffa.Obblighi)} width="20"/>
                    <ReactTooltip id={`Obblighi-${tariffa.Progressivo}`} backgroundColor='#ca0000' effect="solid" html={true}/>
                </>
            }
            {tariffa.AltreInfo != '' &&
                <>
                    <img src={PngAltreInfo} data-for={`AltreInfo-${tariffa.Progressivo}`} data-tip={splitStringByLength(tariffa.AltreInfo)} width="20"/>
                    <ReactTooltip id={`AltreInfo-${tariffa.Progressivo}`} backgroundColor='#1b849f' effect="solid" html={true}/>
                </>
            }
        </>
    );
};


